import React from 'react'
import WithConsumer from "../context/WithConsumer";
import {findMedia} from "../utils/Media";
import Moment from 'react-moment';

class GridItem extends React.PureComponent {

    /**
     * @returns {*}
     */
    render = () => {
        const {post, isOpened} = this.props;
        return (
            <div onClick={this.props.onOpen} className={`Grid__item ${isOpened && 'Grid__item--opened'}`}>
                <div className='Grid__photo' style={{backgroundImage: `url(${this.getMedia()})`}}/>
                <div className='Grid__cover'/>
                <div className='Grid__content'>
                    <h2 className='Grid__title' dangerouslySetInnerHTML={{__html: post.title.rendered}}/>
                    <p className='Grid__date'><Moment format="DD.MM.YYYY">{post.date}</Moment></p>
                    {isOpened && (
                        <button type='button' className='Grid__close' onClick={this.props.onClose}>
                            Zavřít
                        </button>
                    )}
                </div>
            </div>
        )
    };

    /**
     * @returns {string|undefined}
     */
    getMedia = () => {

        const {post, context} = this.props;
        const mediaId = post.featured_media;
        const media = findMedia(mediaId, context.media);
        if (!media) {
            return undefined;
        }

        return media.source_url;
    };
}

export default WithConsumer(GridItem);